import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { size } from 'lodash';
import { HelpIcon } from '../../icons/HelpIcon';
import { showForm } from '../../store/formSlice';

const HelpButtonContainer = () => {
    const dispatch = useDispatch();
    const { grants } = useSelector(state => state.user)

    return(size(grants)
        ? <HelpIcon onClick={() => dispatch(showForm("help"))} />
        : null
    )
};

export { HelpButtonContainer };
